export const checkHasOTTFilledFields = (
  basicInformation: any,
  videoData: any,
  detailMeta: any,
  tags: any,
  previewContentIds: any[],
  imageIds: any[]
): boolean => {
  return (
    Boolean(basicInformation?.title?.trim()) ||
    Boolean(basicInformation?.tagline?.trim()) ||
    Boolean(basicInformation?.description?.trim()) ||
    Boolean(basicInformation?.OverView?.trim()) ||
    Boolean(videoData?.duration) ||
    Boolean(videoData?.runtime) ||
    Boolean(previewContentIds?.length) ||
    Boolean(imageIds?.length) ||
    Boolean(tags?.displayTagData?.length) ||
    Boolean(tags?.filterTagData?.length) ||
    Boolean(tags?.keywordData?.length) ||
    Boolean(detailMeta?.cast?.length) ||
    Boolean(detailMeta?.partners?.length) ||
    Boolean(detailMeta?.studio) ||
    Boolean(detailMeta?.releaseDate) ||
    Boolean(detailMeta?.ottReleaseDate) ||
    Boolean(detailMeta?.tvReleaseDate) ||
    Boolean(detailMeta?.budget) ||
    Boolean(detailMeta?.revenue)
  );
};

export const checkHasCPFilledFields = (
  cpBasic: any,
  cpVideoId: any[]
): boolean => {
  return (
    Boolean(cpBasic?.title?.trim()) ||
    Boolean(cpBasic?.description?.trim()) ||
    Boolean(cpBasic?.language) ||
    Boolean(cpBasic?.channel) ||
    (Array.isArray(cpBasic?.searchTags) && cpBasic.searchTags.length > 0) ||
    (Array.isArray(cpVideoId) && cpVideoId.length > 0)
  );
};
